module.exports = __webpack_public_path__ + "img/thumbnail_PallasCat_j_normal.fd665938.png";